import { Steps } from "intro.js-react";
import React, { useEffect, useState } from "react";
import { ButtonsRight } from "../../interfaces/UI";
import { isDesktop } from "react-device-detect";
import introJs from "intro.js";

interface TourProps {
  startTour?: () => void;
  open: boolean;
  setOpen(o: boolean): void;
  viewButtons: ButtonsRight;
  // setOpenButtons :  (buttosn : ButtonsRight) => void
}

interface Step {
  element: string;
  intro: string;
  position?: string;
}

const Tour = ({
  open,
  setOpen,
  viewButtons: openButtons,
  startTour,
}: TourProps) => {
  // const [stepsEnabled, setStepsEnabled] = useState(open)
  const [steps, setSteps] = useState<Step[]>([]);

  const onExit = () => {
    setOpen(false);
  };

  const addStep = (
    stepsTmp: Step[],
    element: string,
    intro: string,
    position?: string,
  ) => {
    stepsTmp.push({
      element: element,
      intro: intro,
      position,
    });
    return stepsTmp;
  };

  const playSteps = () => {
    let stepsTmp: Step[] = [];

    addStep(
      stepsTmp,
      ".xxx",
      "<h5>Bienvenido a Libros Virtualpro</h5><p>Explora una nueva forma de ver los libros, con contenido teórico e  interactivo.</p>",
    );
    addStep(
      stepsTmp,
      ".tourBtnLeftMenu",
      `<div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
    <h5 style="margin-bottom:8px; margin-top:0px;">Explora el contenido</h5>

    <video
      src="/videos/S1-Menu.mp4"
      style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
      muted
      playsinline
      autoplay
      loop
    ></video>

    <span>
      Conoce y navega por capítulos, secciones y recursos interactivos del libro.
    </span>
  </div>`,
    );

    if (isDesktop) {
      addStep(
        stepsTmp,
        ".BtnFullScreen",
        `
          <div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Pantalla completa</h5>

          <video
            src="/videos/S2-Fullscreen.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Mejora la experiencia en pantalla completa.
          </span>
        </div>
        `,
      );
      addStep(
        stepsTmp,
        ".BtnCustomize",
        `
          <div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Personaliza la experiencia</h5>

          <video
            src="/videos/S3-Config.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Configura el tema de lectura, el idioma y las opciones de visualización.
          </span>
        </div>
        `,
      );
      addStep(
        stepsTmp,
        ".tourBtnFileDoc",
        `<div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Ficha técnica</h5>

          <video
            src="/videos/S4-Ficha.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Consulta la información del libro y genera la citación bibliográfica.
          </span>
        </div>`,
      );
      addStep(
        stepsTmp,
        ".tourBtnIndex",
        `<div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Explora el capítulo</h5>

          <video
            src="/videos/S5-Capitulos.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Navega el capítulo en línea de tiempo y accede a la trivia de conocimiento.
          </span>
        </div>`,
      );
      addStep(
        stepsTmp,
        ".tourPodcastBtn",
        `<div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Podcast</h5>

          <video
            src="/videos/S7-Podcast.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Accede a los podcasts organizados por capítulo para reforzar el contenido del libro.
          </span>
        </div>`,
      );
      addStep(
        stepsTmp,
        ".tourBtnIA",
        `<div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Consulta con IA</h5>

          <video
            src="/videos/S6-Asistente-Ai.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Haz preguntas al asistente inteligente sobre el contenido del libro.
          </span>
        </div>`,
      );
      addStep(
        stepsTmp,
        ".tourBtnReviews",
        `<div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Reseñas</h5>

          <video
            src="/videos/S8-Rating.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Consulta las reseñas de otros usuarios y comparte tu opinión sobre el libro.
          </span>
        </div>`,
      );
      addStep(
        stepsTmp,
        ".tourBtnHelp",
        `<div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Ayuda</h5>

          <video
            src="/videos/S9-Help.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
             Aprende a usar el libro, valora el recurso y accede al centro de soporte.
          </span>
        </div>`,
      );
    } else {
      addStep(
        stepsTmp,
        ".BtnFullScreen-BtnCustomizeMobile",
        `
        <div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Pantalla completa</h5>

          <video
            src="/videos/S2-Fullscreen.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Mejora la experiencia en pantalla completa.
          </span>
        </div>
        `,
      );
      addStep(
        stepsTmp,
        "#group-btn",
        "<h5>Herramientas del Libro</h5><p>Accede a funciones clave como la línea de tiempo del capítulo, trivia, ficha técnica, asistencia con IA y soporte. Todo lo que necesitas, en un solo lugar.</p>",
        "top",
      );
    }

    addStep(
      stepsTmp,
      ".pager",
      `
          <div style="text-align:center; display:flex; flex-direction:column; align-items:center;">
          <h5 style="margin-bottom:8px; margin-top:0px;">Navega el libro</h5>

          <video
            src="/videos/S10-Pager.mp4"
            style="max-width:40%; height:auto; margin-bottom:10px; border-radius:8px;"
            muted
            playsinline
            autoplay
            loop
          ></video>

          <span>
            Avanza o retrocede sección a sección en el contenido del libro.
          </span>
        </div>
        `,
    );
    setSteps(stepsTmp);
    if (localStorage.getItem("isFirstViewTest") !== "true") {
      localStorage.setItem("isFirstViewTest", "true");
    }
    setOpen(true);
  };

  useEffect(() => {
    const isFirstViewTest = (localStorage.getItem("isFirstViewTest") || "")
      .trim()
      .toLowerCase();
    if (isFirstViewTest !== "true") {
      setTimeout(() => {
        setOpen(true);
      }, 2000);
    }
  }, []);

  useEffect(() => {
    if (open && steps.length === 0) {
      playSteps();
    }
  }, [open]);

  //https://github.com/HiDeoo/intro.js-react#introjs-options
  const options = {
    nextLabel: ">>",
    prevLabel: "<<",
    showProgress: true,
  };

  return (
    <div>
      <Steps
        enabled={open}
        steps={steps}
        initialStep={0}
        onExit={onExit}
        options={options}
      />
    </div>
  );
};

export default Tour;
